import { SvgTypesProps } from '@/shared/types/SvgTypes';

export function IconMessage2({
  fill = 'var(--accent-230)',
  width = 20,
  height = 20,
}: SvgTypesProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.806 8.25h8m-8 4h4m-9-2.5a9 9 0 1 1 6.985 8.773 4.202 4.202 0 0 0-1.903-.015c-1.396.33-3.322.597-4.64.222-.555-.158-.61-.845-.342-1.356.311-.595.582-1.328.787-1.978.229-.73.084-1.506-.208-2.212A8.973 8.973 0 0 1 .806 9.75Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}